import {useEffect, useRef, useState} from "react";

const RowTRComponentInput = ({
    fieldName,
    fieldText = null,
    _TC,
    valueIn = "",
    styleCenterMiddle,
    type = "text",
    inputProps = {},
    onChangeExternal = null,
}) => {
    const [value, setValue] = useState("");
    const last = useRef(null);
    const fallbackStyle = {textAlign: "center", verticalAlign: "middle"};
    const extraCellStyle = styleCenterMiddle ?? fallbackStyle;

    if (fieldText === null) {
        fieldText = fieldName;
    }
    useEffect(() => {
        setValue(valueIn);
        last.current = valueIn;
    }, [valueIn]);

    const handleChange = (e) => {
        setValue(e.target.value);
        if (onChangeExternal) {
            onChangeExternal(e);
        }
    };

    return (
        <tr>
            <td className="align-middle">{_TC(`${fieldName}.name`)}</td>
            <td className="align-middle">{_TC(`${fieldText}.description`)}</td>
            <td className="align-middle">
                <div className="d-flex justify-content-end align-items-center">
                    <label htmlFor={fieldName} className="form-label me-2 mb-0">
                        {_TC(`${fieldText}.params`)}
                    </label>
                    <input
                        type={type}
                        id={fieldName}
                        name={fieldName}
                        className="form-control text-end"
                        style={{maxWidth: "120px"}}
                        title={_TC(fieldName)}
                        value={value}
                        onChange={handleChange}
                        {...inputProps}
                    />
                </div>
            </td>
            <td className="align-middle" style={extraCellStyle}></td>
        </tr>
    );
};
export default RowTRComponentInput;
